import type { Seat } from '@shared/engine';

function Track(props: { who: 'you' | 'opp'; name: string; score: number; prev: number; dealer: boolean }) {
  const pct = (n: number) => `${Math.min(100, (n / 121) * 100)}%`;
  return (
    <div className={`track ${props.who}`}>
      <div className="label">
        <span className="name">
          {props.name}
          {props.dealer ? <span className="dealer-dot"> ● deals</span> : null}
        </span>
      </div>
      <div className="rail" aria-hidden="true">
        <div className="ticks" />
        <div className="peg back" style={{ left: pct(props.prev) }} />
        <div className="peg" style={{ left: pct(props.score) }} />
      </div>
    </div>
  );
}

export function Board(props: { you: Seat; names: [string, string]; scores: [number, number]; prev: [number, number]; dealer: Seat | null }) {
  const opp = props.you === 0 ? 1 : 0;
  return (
    <div className="board" aria-hidden="true">
      <Track who="you" name={props.names[props.you]} score={props.scores[props.you]} prev={props.prev[props.you]} dealer={props.dealer === props.you} />
      <div className="mid">
        <span className="score you">{props.scores[props.you]}</span>
        <span className="dash">–</span>
        <span className="score opp">{props.scores[opp]}</span>
      </div>
      <Track who="opp" name={props.names[opp]} score={props.scores[opp]} prev={props.prev[opp]} dealer={props.dealer === opp} />
    </div>
  );
}
